
//30有誠的按鈕群
import React, { useState, useEffect, ReactEventHandler, Component } from "react";
import { Close } from "./SVG";

interface HModalProps {
    title?: string
    children?: String | React.ReactNode
    //children?: JSX.Element|JSX.Element[];
    className?: string
    show?: boolean
    type?: string
    showCross?: boolean | true
    cancel?: () => void
    confirm?: () => void
}

export class HibModal extends Component<HModalProps> {
    render() {
        const { title,children, show, type,  showCross, className, cancel, confirm, ...props } = this.props as HModalProps;
        return (
            <div  className={"hibModal " + (show ? "open" : "") + (className ? " " + className : "")}>
                <div className={"modalContent "+ (type ? type :"full")}>
                    <div className="modalHeader">
                        <div className="close" onClick={cancel}>
                            <Close/>
                        </div>
                        <div className="title">
                            {title}
                        </div>
                    </div>
                    <div className="modalBody">
                        <div className="confirmMesg">
                            {children}
                        </div>                         
                    </div>
                </div>
            </div>
        )
    }
}
